var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PersonPlan',{attrs:{"orderType":_vm.orderType,"submitText":_vm.orderObj[_vm.orderType].submitText,"submitApi":_vm.submitApi,"params":_vm.orderObj[_vm.orderType].params,"list":_vm.orderObj[_vm.orderType].list,"source":_vm.orderObj[_vm.orderType].source},on:{"orderCreateSuccess":_vm.orderCreateSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }